<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存
    -->
  <div>
    <!--会员折扣设置-->
    <div class="common-form mt50">会员折扣设置</div>
    <el-form-item label="是否开启会员折扣：">
      <el-radio-group v-model="form.model.is_enable_grade">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="模式设置：">
      <el-radio-group v-model="form.model.grade_model" @change="checkModel">
        <el-radio :label="0">折扣模式</el-radio>
        <el-radio :label="1">返佣模式</el-radio>
      </el-radio-group>
      <div class="gray9">折扣模式：下单按折扣价计算，返佣模式：原价下单，折扣金额已佣金形式返还</div>
    </el-form-item>
    <el-form-item label="是否开启级差：" v-if="form.model.grade_model==1">
      <el-radio-group v-model="form.model.is_level_difference">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- <el-form-item label="同级奖励：" v-if="form.model.grade_model==1">
      <el-input v-model="form.model.lateral_ratio" type="number" placeholder="请输入同级奖励比例" class="max-w460" >
        <template slot="append">%</template>
      </el-input>
      <div class="max-w460">
        <el-table
          :data="form.gradeList"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="会员等级">
          </el-table-column>
          <el-table-column
            prop="name"
            label="奖励">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_lateral_ratio" value="0" type="number" placeholder="请输入奖励"></el-input>
                <span class="ml10">%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item> -->
    <el-form-item label="会员折扣设置：">
      <el-radio-group v-model="form.model.is_alone_grade">
        <el-radio :label="0" :disabled="form.model.grade_model==1?true:false">默认折扣</el-radio>
        <el-radio :label="1" >单独设置折扣(百分比)</el-radio>
        <el-radio :label="2">单独设置折扣(固定金额)</el-radio>
      </el-radio-group>
      <div class="gray9" v-if="form.model.is_alone_grade==0">默认折扣：默认为用户所属会员等级的折扣率</div>
      <div v-if="form.model.is_alone_grade==1" class="max-w460">
        <el-table
          :data="form.gradeList"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="会员等级">
          </el-table-column>
          <el-table-column
            prop="name"
            label="折扣">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_equity" type="number" placeholder="请输入折扣"></el-input>
                <span class="ml10">%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="form.model.is_alone_grade==2" class="max-w460">
        <el-table
          :data="form.gradeList"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="会员等级">
          </el-table-column>
          <el-table-column
            prop="name"
            label="金额">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_fixed" type="number" placeholder="请输入金额"></el-input>
                <span class="ml10">元</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

    <el-form-item label="是否开启平级奖励：" v-if="form.model.grade_model==1">
      <el-radio-group v-model="form.model.is_lateral">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="平级奖励：" v-if="form.model.is_lateral==1 && form.model.grade_model==1">
      <div class="max-w460">
        <el-table
          :data="form.gradeList"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="会员等级">
          </el-table-column>
          <el-table-column
            prop="name"
            label="奖励">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_lateral_ratio" value="0" type="number" placeholder="请输入奖励"></el-input>
                <span class="ml10">%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

  </div>
</template>

<script>
export default {
  components: {},
  inject: ['form'],
  methods: {
    checkModel(e){
      if(e==1 && this.form.model.is_alone_grade==0){
        this.form.model.is_alone_grade = 1;
      }
    },
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Spec.vue